"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component } from "vue-property-decorator";
import { GeneralGridResult, GeneralSearchQuery } from "../grid/core";
import { APIDataSource } from "../grid/data-source";
import { VirtualShopItemColumn } from "./item";
import { ControllerComponent } from "@/components/core";
import _ from "lodash";
import { AccountSessionStorage } from "@/service/account-session";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import { TimerEngine } from "@/utils/settimeout";
export class Controller {
  constructor() {
    // base.auth.pro
    // 店铺列表
    // "api://base.auth.kv.shops/v1/shops",
    this.dataSource = new APIDataSource(
      // "api://base.auth/api/v7/groups/shop_list_new",
      // "api://base.auth.kv.shops/v1/shops",
      "api://base.auth.pro/v1/shops",
      {
        factory: (item) => {
          return VirtualShopItemColumn.create(item);
        }
      }
    );
    this._gridResult = new GeneralGridResult();
    this._query = new GeneralSearchQuery();
    this._loading = false;
    this._mode = "items";
    // protected _onlineService: Optional<OnlineService> = null;
    this._select = [];
  }
  search() {
    return __async(this, null, function* () {
      this._loading = true;
      let _query = __spreadValues({}, this.query);
      _query.params = __spreadProps(__spreadValues({}, _query.params), { type: "SHOW" });
      _query.filter = ((obj) => {
        let str = "";
        str = "hide==false;";
        for (const prop in obj) {
          if (Array.isArray(this._query.filter[prop])) {
            if (!this._query.filter[prop].length) {
              continue;
            }
            if (prop === "expiryDate") {
              continue;
            }
            let substr = `${prop}=in=(`;
            this._query.filter[prop] = this._query.filter[prop].map(
              (item) => {
                if (item.indexOf('"') !== -1) {
                  return item;
                } else {
                  return `"${item}"`;
                }
              }
            );
            substr += this._query.filter[prop].join(",");
            str += `${substr});`;
          } else {
            if (this._query.filter[prop] === null) {
              continue;
            }
            if (prop === "name") {
              str += `${prop}=like="${obj[prop]}";`;
            } else if (prop === "loginStartTime") {
              str += `lastLoginTime=between=(${Date.parse(obj["loginStartTime"]) / 1e3},${Date.parse(obj["loginEndTime"]) / 1e3});`;
            } else if (prop === "loginEndTime") {
              continue;
            } else if (prop === "bindVd") {
              if (obj[prop] === true) {
                str += `status==BIND_VD;`;
              } else if (obj[prop] === false) {
                str += `status==NOT_BIND_VD;`;
              } else {
                continue;
              }
            } else if (prop === "ip") {
              if (obj[prop] !== "") {
                str += `${prop}=="${obj[prop]}";`;
              }
            } else {
              str += `${prop}=="${obj[prop]}";`;
            }
          }
        }
        return str;
      })(_query.filter);
      if (_query.sort) {
        if (_query.sort === "createdTime,desc") {
          _query.filter = _query.filter + "createdTime=sort=desc;";
        }
        if (_query.sort === "createdTime,asc") {
          _query.filter = _query.filter + "createdTime=sort=asc;";
        }
        if (_query.sort === "name,asc") {
          _query.filter = _query.filter + "nameSort=sort=asc;";
        }
        if (_query.sort === "name,desc") {
          _query.filter = _query.filter + "nameSort=sort=desc;";
        }
        if (_query.sort === "ip,asc") {
          _query.filter = _query.filter + "ipSort=sort=asc;";
        }
        if (_query.sort === "ip,desc") {
          _query.filter = _query.filter + "ipSort=sort=desc;";
        }
        if (_query.sort === "authUserCount,asc") {
          _query.filter = _query.filter + "authUserCount=sort=asc;";
        }
        if (_query.sort === "authUserCount,desc") {
          _query.filter = _query.filter + "authUserCount=sort=desc;";
        }
        if (_query.sort === "shopSort,asc") {
          _query.filter = _query.filter + "shopSort=sort=asc;";
        }
        if (_query.sort === "shopSort,desc") {
          _query.filter = _query.filter + "shopSort=sort=desc;";
        }
        if (_query.sort === "lastOpenTimeSort,asc") {
          _query.filter = _query.filter + "lastOpenTimeSort=sort=asc;";
        }
        if (_query.sort === "lastOpenTimeSort,desc") {
          _query.filter = _query.filter + "lastOpenTimeSort=sort=desc;";
        }
      }
      const _datas = yield this.dataSource.search(_query);
      this._gridResult = _datas;
      let response = yield API.get(`api://base.local/v2/dynamic-browsers`);
      for (const item of response.data.data) {
        const _item = _.find(_datas.datas, {
          shopOldId: item.id
        });
        if (_item) {
          _item.runtime.status = "open";
        }
      }
      this._loading = false;
    });
  }
  result() {
    return this._gridResult;
  }
  get loading() {
    return this._loading;
  }
  get mode() {
    return this._mode;
  }
  set mode(mode) {
    this._mode = mode;
  }
  get query() {
    return this._query;
  }
  get selected() {
    return this._select;
  }
  // public get onlineService() {
  //   if (this._onlineService === null) {
  //     this._onlineService = new OnlineService("shop");
  //   }
  //   return this._onlineService;
  // }
}
let VirtualDesktopContent = class extends ControllerComponent {
  constructor() {
    super(...arguments);
    //websocket实例对象
    this.webSocketService = WebsocketViewService;
    //轮询视图控制器
    this.view_listener = null;
    this.clientVersion = "6.8.1";
    this.systemVersionData = null;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield Promise.all([this.setupWebSocketListeners(), this.initializeData()]);
    });
  }
  setupWebSocketListeners() {
    return __async(this, null, function* () {
      const ipcEvent = this.webSocketService._ipcEvent;
      ipcEvent.on("event:clientEvent.subBrowser.launch", (data) => __async(this, null, function* () {
        const _item = _.find(this.$controller.result().datas, {
          id: data.data.new_shop_id
        });
        if (_item) {
          const _timeout = setTimeout(() => {
            _item.runtime.status = "open";
          }, 1e3);
        }
      }));
      ipcEvent.on(
        "event:clientEvent.dynamicBrowser.terminal",
        (data) => __async(this, null, function* () {
          const _item = _.find(this.$controller.result().datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            const _timeout = setTimeout(() => {
              _item.runtime.status = "ready";
            }, 1e3);
          }
        })
      );
      ipcEvent.on(
        "event:clientEvent.subBrowser.launch.error",
        (data) => __async(this, null, function* () {
          yield this.manageError(data);
        })
      );
      ipcEvent.on(
        "event:clientEvent.subBrowser.launch.progress",
        (data) => __async(this, null, function* () {
          const _item = _.find(this.$controller.result().datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            _item.launcher_progress = data.data.progress;
            if (_item.launcher_progress === 100) {
              const _timeout = setTimeout(() => {
                _item.launcher_progress = 0;
                _item.runtime.status = "open";
              }, 1e3);
            }
          }
        })
      );
    });
  }
  initializeData() {
    return __async(this, null, function* () {
      try {
        yield this.getVersion();
        yield this.getView();
      } catch (error) {
        console.error("Failed to initialize data:", error);
      }
    });
  }
  getVersion() {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        this.clientVersion = _version;
        this.systemVersionData = version_response.data;
      } catch (error) {
        console.log(error);
      }
    });
  }
  getView() {
    return __async(this, null, function* () {
      this.view_listener = new TimerEngine(() => __async(this, null, function* () {
        try {
          let shop_ids = _.map(this._controller.result().datas, "shopOldId");
          let response = yield API.post(
            `api://base.auth.view/api/v1/online-users/shop`,
            {
              ids: shop_ids
            }
          );
          for (const _item of response.data.datas) {
            const _column = _.find(this.$controller.result().datas, {
              shopOldId: _item.shopId
            });
            if (_column) {
              let _onLineList = {
                total: _item.users.length,
                datas: _item.users
              };
              _column.onLineList = _onLineList;
            }
          }
        } catch (error) {
        }
      }), 2e4);
      this.view_listener.start();
    });
  }
  /**
   * 判断是否为cookie失效导致的错误
   * @param error 错误对象
   * @returns 是否为cookie失效
   */
  isCookieExpired(error) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 401 || ((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) === 403) {
      return true;
    }
    if (((_g = (_f = (_e = (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data) == null ? void 0 : _d.errors) == null ? void 0 : _e.datas) == null ? void 0 : _f[0]) == null ? void 0 : _g.code) === "token.error" || ((_j = (_i = (_h = error == null ? void 0 : error.errors) == null ? void 0 : _h.datas) == null ? void 0 : _i[0]) == null ? void 0 : _j.code) === "token.error") {
      return true;
    }
    if ((error == null ? void 0 : error.hasOwnProperty("response")) && (((_k = error.response) == null ? void 0 : _k.status) === 401 || ((_l = error.response) == null ? void 0 : _l.status) === 403)) {
      return true;
    }
    return false;
  }
  manageError(data) {
    return __async(this, null, function* () {
      var _a, _b;
      const _item = _.find(this.$controller.result().datas, {
        shopOldId: data.data.id
      });
      if (_item) {
        const _timeout = setTimeout(() => {
          _item.runtime.status = "ready";
        }, 1e3);
      }
      if (this.isCookieExpired(data.data.error)) {
        this.$message.error(
          this.$t("main.shop_launch_cookie_expired")
        );
        return;
      }
      if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.shop") {
        if (((_a = AccountSessionStorage.getSession()) == null ? void 0 : _a.type) === "user") {
          this.$message.error(this.$t("shop.user_lock_error_message"));
        } else {
          this.$message.error(this.$t("shop.account_lock_error_message"));
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.vd") {
        if (((_b = AccountSessionStorage.getSession()) == null ? void 0 : _b.type) === "user" && !AccountSessionStorage.getSession().permissions.is("SHOW_ALL_MENUS")) {
          this.$message.error(this.$t("vd.user_lock_error_message"));
        } else {
          this.$message.error(this.$t("vd.account_lock_error_message"));
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "browser") {
        let time = sessionStorage.getItem("browser_retry_times");
        if (time === null) {
          time = "1";
          sessionStorage.setItem("browser_retry_times", time);
          this.$message.info(
            this.$t("main.shop_launch_browser_error_info")
          );
          let env_response = yield API.get(
            `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
          );
          let code = env_response.data.appData.browser.code;
          let version = env_response.data.appData.browser.version;
          yield API.delete(
            `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
          );
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
          try {
            yield API.get(
              `api://base.local/storages/preference/mainExtensionVersion`
            );
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher_new",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } catch (error) {
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          }
        } else if (time !== null && Number(time) < 3) {
          time = (Number(time) + 1).toString();
          sessionStorage.setItem("browser_retry_times", time);
          this.$message.info(
            this.$t("main.shop_launch_browser_error_info")
          );
          let env_response = yield API.get(
            `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
          );
          let code = env_response.data.appData.browser.code;
          let version = env_response.data.appData.browser.version;
          yield API.delete(
            `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
          );
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
        } else {
          if (this.isCookieExpired(data.data.error)) {
            this.$message.error(
              this.$t("main.shop_launch_cookie_expired")
            );
          } else {
            this.$message.error(
              this.$t("main.shop_launch_browser_error_message")
            );
          }
        }
      } else if (data.data.error.hasOwnProperty("response")) {
        if (data.data.error.response.data.hasOwnProperty("errors") && data.data.error.response.data.errors.datas[0].code === "browser.resource.not.exist") {
          const h2 = this.$createElement;
          if (data.data.error.browser_core === "firefox") {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t(
                      "main.shop_visit_browser_firefox_resorce_tip"
                    )
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          } else if (data.data.error.browser_core === "chrome") {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t(
                      "main.shop_visit_browser_chrome_resorce_tip"
                    )
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          } else {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t("main.shop_visit_browser_resorce_tip")
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          }
        } else if (data.data.error.response.data.hasOwnProperty("errors") && data.data.error.response.data.errors.datas[0].code === "browser") {
          let time = sessionStorage.getItem("browser_retry_times");
          if (time === null) {
            time = "1";
            sessionStorage.setItem("browser_retry_times", time);
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(
              `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
            );
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
            );
            yield API.post(`api://base.local/websockets/view`, {
              model: "virtualbrowser.launcher.restart",
              value: {
                vd_guid: data.data.vd_id,
                shop_id: data.data.id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
            try {
              yield API.get(
                `api://base.local/storages/preference/mainExtensionVersion`
              );
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.launcher_new",
                value: {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } catch (error) {
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.launcher",
                value: {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            }
          } else if (time !== null && Number(time) < 3) {
            time = (Number(time) + 1).toString();
            sessionStorage.setItem("browser_retry_times", time);
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(
              `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
            );
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
            );
            yield API.post(`api://base.local/websockets/view`, {
              model: "virtualbrowser.launcher.restart",
              value: {
                vd_guid: data.data.vd_id,
                shop_id: data.data.id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher_new",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } else {
            if (this.isCookieExpired(data.data.error)) {
              this.$message.error(
                this.$t("main.shop_launch_cookie_expired")
              );
            } else {
              this.$message.error(
                this.$t("main.shop_launch_browser_error_message")
              );
            }
          }
        } else if (data.data.error.code === "ERR_BAD_REQUEST") {
          try {
            let time = sessionStorage.getItem("browser_retry_times");
            let env_response = yield API.get(
              `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
            );
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            if (time === null) {
              time = "1";
              sessionStorage.setItem("browser_retry_times", time);
              yield API.delete(
                `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
              );
              yield API.post(`api://base.local/websockets/view`, {
                model: "virtualbrowser.launcher.restart",
                value: {
                  vd_guid: data.data.vd_id,
                  shop_id: data.data.id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.launcher_new",
                value: {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } else if (time !== null && Number(time) < 3) {
              time = (Number(time) + 1).toString();
              sessionStorage.setItem("browser_retry_times", time);
              yield API.delete(
                `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
              );
              yield API.post(`api://base.local/websockets/view`, {
                model: "virtualbrowser.launcher.restart",
                value: {
                  vd_guid: data.data.vd_id,
                  shop_id: data.data.id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.launcher_new",
                value: {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } else {
              if (this.isCookieExpired(data.data.error)) {
                this.$message.error(
                  this.$t("main.shop_launch_cookie_expired")
                );
              } else {
                this.$message.error(
                  this.$t("main.shop_launch_browser_error_message")
                );
              }
            }
          } catch (error) {
            if (this.isCookieExpired(data.data.error)) {
              this.$message.error(
                this.$t("main.shop_launch_cookie_expired")
              );
            } else {
              this.$message.error(
                this.$t("main.shop_launch_browser_error_message")
              );
            }
          }
        }
      } else if (data.data.error.hasOwnProperty("message") && data.data.error.message === "upgrade Browser Core") {
      } else if (data.data.error.code === "ERR_BAD_REQUEST") {
        let env_response = yield API.get(
          `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
        );
        let code = env_response.data.appData.browser.code;
        let version = env_response.data.appData.browser.version;
        yield API.delete(
          `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
        );
        let time = sessionStorage.getItem("browser_retry_times");
        if (time === null) {
          time = "1";
          sessionStorage.setItem("browser_retry_times", time);
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
          try {
            yield API.get(
              `api://base.local/storages/preference/mainExtensionVersion`
            );
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher_new",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } catch (error) {
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          }
          this.$message.error(this.$t("main.shop_launcher_loading"));
        } else {
        }
      } else if (data.data.error.code === "ERR_DISK_ROOM_NOT_ENOUGH") {
        yield UiConfirm.warnconfirm(this.$t("main.shop_launcher_disk_room_not_enough"), this.$t("main.shop_launcher_disk_room_not_enough_title"), {
          confirmButtonText: this.$t("main.confirm"),
          showCancelButton: false,
          iconClass: "el-icon-warning"
        });
      } else {
        if (this.isCookieExpired(data.data.error)) {
          this.$message.error(
            this.$t("main.shop_launch_cookie_expired")
          );
        } else {
          this.$message.error(
            this.$t("main.shop_launch_browser_error_message")
          );
        }
      }
    });
  }
  //切页
  currentChange(current) {
    this.$emit("pageChange", current);
    localStorage.setItem("shop.page", current.toString());
    this._controller.query.current = current;
    this.$controller.search();
  }
  //切换每页显示条数
  sizeChange(size) {
    this.$emit("sizeChange", size);
    localStorage.setItem("shop.size", size.toString());
    localStorage.setItem("shop.page", "1");
    this._controller.query.size = size;
    this._controller.query.current = 1;
    this.$controller.search();
  }
  //前往帮助页面
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
  //Vue自带方法 页面销毁前调用
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
    if (this.view_listener !== null) {
      this.view_listener.stop();
    }
  }
};
__decorateClass([
  Debounce(600)
], VirtualDesktopContent.prototype, "manageError", 1);
VirtualDesktopContent = __decorateClass([
  Component({})
], VirtualDesktopContent);
export {
  VirtualDesktopContent as default
};
